module.exports = __webpack_public_path__ + "img/m13.ce33bfe.jpg";